import axios, {AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { API_URL } from "../constant";
import { ErrorResponse} from "../constant";
  
export async function DownloadExcelAccount(licenseNumber: string): Promise<ErrorResponse> {
    try {
        const token = localStorage.getItem("token")
        
        const config: AxiosRequestConfig = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            responseType: "blob",
          };
      
        const response: AxiosResponse  = await axios.post(
          `${API_URL}api/accounting/excelOutAccounting`,
          {licenseNumber: licenseNumber},
          config,
        );
    
        if (response.status === 200)
        {
            const disposition = response.headers["content-disposition"];
            let filename = "data.xlsx";
      
            if (disposition) {
                const matches = disposition.match(/filename="([^"]+)"/);
                console.log(matches)
                if (matches && matches[1]) {
                    filename = matches[1];
                }
            }

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = filename; 
            link.click();
            window.URL.revokeObjectURL(url);
            return { success: true, errorMsg: "download success" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}